import { render } from "./CmorInvio.vue?vue&type=template&id=22af48e4&scoped=true"
import script from "./CmorInvio.vue?vue&type=script&lang=js"
export * from "./CmorInvio.vue?vue&type=script&lang=js"

import "./CmorInvio.vue?vue&type=style&index=0&id=22af48e4&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22af48e4"]])

export default __exports__